import React from 'react';
import * as S from './../styles/styles';
import { motion } from "framer-motion";
import { FaBehance, FaRegStar } from "react-icons/fa";
import { FaLinkedinIn } from "react-icons/fa6";
import { useMediaQuery } from 'react-responsive';
import { Link } from 'react-router-dom';

import logoPng from './../styles/logo3.png';
import img1 from './../styles/imgado.png';
import img2 from './../styles/imgfig.png';
import img3 from './../styles/imgble.png';

const containerVariants = {
  hidden: { opacity: 0 },
  visible: { 
    opacity: 1, 
    transition: { staggerChildren: 0.1 } 
  }
};

const itemVariants = {
  hidden: { y: 10, opacity: 0 },
  visible: { y: 0, opacity: 1 }
};

const About = () => {
  const isMobile = useMediaQuery({ query: '(max-width: 767px)' });

  const itens = [
    { id: 1, img: img1 },
    { id: 2, img: img2 },
    { id: 3, img: img3 },
  ];

  return (
    <S.AppAbout>
      
      {/* HEADER */}
      <S.Header>
        {!isMobile && (
          <>
            <Link to="/home" viewTransition style={{ textDecoration: 'none', color: 'white' }}>Home</Link>
            <Link to="/about" viewTransition style={{ textDecoration: 'none', color: 'white' }}>About</Link>
            <Link to="/gallery" viewTransition style={{ textDecoration: 'none', color: 'white' }}>Gallery</Link>
          </>
        )}

        <S.SymbolGroup>
          <a href="https://www.linkedin.com/in/mariasouza-dan/" target="_blank" rel="noreferrer">
            <S.SymbolLinkedin><FaLinkedinIn /></S.SymbolLinkedin>
          </a>
          <a href="https://www.behance.net/Dandelious" target="_blank" rel="noreferrer">
            <S.SymbolBehance><FaBehance /></S.SymbolBehance>
          </a>
        </S.SymbolGroup>
      </S.Header>

      <S.WhiteHeaderDivider />

      {/* MAIN */}
      <main
        style={{
          padding: isMobile ? '20px' : '60px 5%',
          color: 'white',
          display: 'flex',
          flexDirection: isMobile ? 'column' : 'row',
          justifyContent: 'space-between',
          alignItems: 'flex-start',
          minHeight: '80vh',
          gap: '40px'
        }}
      >

        {/* COLUNA ESQUERDA */}
        <div
          style={{
            display: 'flex',
            flexDirection: 'column',
            flex: isMobile ? '1' : '0 0 50%',
            zIndex: 2,
            alignItems: 'flex-start',
            gap: '20px'
          }}
        >

          {/* TÍTULO */}
          <h1
            style={{
              fontSize: isMobile ? '48px' : '84px',
              fontWeight: 'bold',
              fontFamily: 'Memphis LT PRO',
              lineHeight: '0.9',
              margin: 0
            }}
          >
            About Me
          </h1>

          {/* TEXTO */}
          <div
            style={{
              fontSize: isMobile ? '18px' : '22px',
              lineHeight: '1.6',
              color: '#e0e0e0',
              fontFamily: 'Memphis',
              maxWidth: '650px'
            }}
          >
            <p>
              I'm a passionate designer with <strong>+4 years</strong> of experience, dedicated to bringing ideas to life through design. With experience working with clients in Italy, Australia, the United States, and France, as well as Brazil.
            </p>

            <p style={{ marginTop: '16px' }}>
              My international journey has strengthened my cultural understanding, allowing me to create authentic and impactful designs.
            </p>
          </div>


          <S.BentoGridAbout
            as={motion.div}
            variants={containerVariants}
            initial="hidden"
            animate="visible"
            style={{
              display: 'grid',
              gridTemplateColumns: isMobile ? 'repeat(2, 1fr)' : 'repeat(3, 1fr)',
              gap: '15px',
              width: '100%',
              maxWidth: '500px',
              marginTop: '10px'
            }}
          >
            {itens.map((item) => (
              <S.BentoItem
                key={item.id}
                variants={itemVariants}
                whileHover={{ scale: 1.05 }}
                style={{
                  height: '80px',
                  borderRadius: '15px',
                  overflow: 'hidden'
                }}
              >
                <img
                  src={item.img}
                  alt=""
                  style={{
                    width: '100%',
                    height: '100%',
                    objectFit: 'cover'
                  }}
                />
              </S.BentoItem>
            ))}
          </S.BentoGridAbout>

        </div>

        {!isMobile && (
          <div
            style={{
              flex: '0 0 45%',
              display: 'flex',
              justifyContent: 'center',
              alignItems: 'center'
            }}
          >
            <S.MainLogo
              src={logoPng}
              alt="Logo"
              style={{
                width: '900px',
                height: 'auto',
                maxWidth: '900px',
                opacity: 0.9

              }}
            />
          </div>
        )}

      </main>
      <S.Footer>
         {!isMobile && (
           <S.FooterText style={{ position: 'relative', marginTop: '20px', fontSize: '40px' }}>
                Dandelious Designer <FaRegStar />
            </S.FooterText>
            )}
            <S.BarraVertical />
             <S.FooterNav>
              <Link viewTransition to="/about"><span>About</span></Link>
              <Link viewTransition to="/home"><span>Home</span></Link>
              <Link viewTransition to="/gallery"><span>Gallery</span></Link>
            </S.FooterNav>
           <S.ContactBox>
            <S.ContactHeader>Contact</S.ContactHeader>
            <S.ContactBody>dandelious.design@gmail.com</S.ContactBody>
           </S.ContactBox>
        </S.Footer>

    </S.AppAbout>
  );
};

export default About;